module.exports = __webpack_public_path__ + "static/media/120.be262836.svg";